import moment from 'moment-timezone';
import { ValidDateFormats } from '../Shared/DateUtilities';
export var selectableDurationTypes = [{ value: 'days' }, { value: 'weeks' }, { value: 'months' }];
export var getDuration = function (expiresOnMoment, performedOnMoment, durationType) {
    if (expiresOnMoment && expiresOnMoment.isValid() && performedOnMoment && performedOnMoment.isValid())
        return expiresOnMoment.diff(performedOnMoment, durationType.value).toString();
    return '';
};
export var getDurationType = function (expiresOnMoment, performedOnMoment) {
    if (expiresOnMoment && expiresOnMoment.isValid() && performedOnMoment && performedOnMoment.isValid()) {
        if (expiresOnMoment.isSame(performedOnMoment))
            return { value: 'days' };
        var months = expiresOnMoment.diff(performedOnMoment, 'months', true);
        if (months % 1 === 0)
            return { value: 'months' };
        var weeks = expiresOnMoment.diff(performedOnMoment, 'weeks', true);
        if (weeks % 1 === 0)
            return { value: 'weeks' };
    }
    return { value: 'days' };
};
export var durationLessThanOneYear = function (expiresOnMoment, performedOnMoment) {
    if (expiresOnMoment && expiresOnMoment.isValid() && performedOnMoment && performedOnMoment.isValid()) {
        var years = expiresOnMoment.diff(performedOnMoment, 'years', true);
        return years <= 1;
    }
    return true;
};
// to normalise to end of day
export var expiryDate = function (expiresOn) {
    return !!expiresOn ? moment(expiresOn, ValidDateFormats.IsoFormat).endOf('day') : null;
};
// to normalise to end of day
export var performedDate = function (performedOn, validDateFormats) {
    return !!performedOn ? moment(performedOn, validDateFormats).endOf('day') : null;
};
